import React from "react";
import { updateOrCreateWebhook, pullCampaignWebhooks } from "../../../store/api/calls";
import DataTable from "../../theme/tables/DataTable";
import BaseModal from "../../theme/modals/BaseModal";
import BaseForm from "../../theme/forms/BaseForm";
import Moment from "moment";

class WebhooksTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editModalOpen: false,
      editModalErrorMsg: null,
      editingInstance: {},
      formInputs: [],
    };
  }

  componentDidMount() {
    pullCampaignWebhooks();
  }

  _filterKeysForWebhookDataTable = () => {
    return this.props.webhooks.map((d) => ({
      name: d.name,
      endpoint: d.endpoint,
      created_on: new Moment(d.created_at).format("MM/DD/YY"),
      _created_on: new Moment(d.created_at),
      _data: { ...d, headers: JSON.stringify(d.headers) },
    }));
  };

  _generateFormInputs = () => {
    return [
      {
        type: "text",
        title: "Name",
        dataKey: "name",
        placeholder: "Name this something identifiable",
      },
      {
        type: "text",
        title: "Endpoint",
        dataKey: "endpoint",
        placeholder: "dumpdatahere.io/listener",
      },
      {
        type: "text",
        title: "Headers",
        dataKey: "headers",
        placeholder: "must be valid JSON",
      },
    ];
  };

  onOpenEditModal = (modelInstance = {}, creating = false) => {
    this.setState({
      formInputs: this._generateFormInputs(),
      editModalOpen: true,
      editingInstance: modelInstance,
    });
  };

  onCloseEditModal = () => {
    this.setState({
      editModalOpen: false,
      editingInstance: {},
      editModalErrorMsg: null,
    });
  };

  handleUpdateCreateSubmission = (data) => {
    const id = this.state.editingInstance.id;
    if (id) data = { ...data, id };

    let headers;
    if (data.headers) {
      try {
        headers = JSON.parse(data.headers);
      } catch {
        this.setState({
          editModalErrorMsg: "Your headers are invalid JSON.",
        });
        return;
      }
    }

    updateOrCreateWebhook({
      ...data,
      headers,
      campaign: this.props.focusedCampaign.id,
    })
      .then(() => {
        this.onCloseEditModal();
        this.props.showSuccess();
      })
      .catch((err) => {
        this.props.setError("Failed to update webhook");
      });
  };

  render() {
    return (
      <div>
        <div className="button-table-top-wrapper">
          <h5>
            Caution! If you don't know what you are doing here, please leave
            it to a technical administrator. Once created, webhooks can only
            be deleted by a database admin. All header files must be entered in
            as valid JSON.
          </h5>
        </div>

        <div className="button-table-top-wrapper">
          <a className="button" onClick={() => this.onOpenEditModal({}, true)}>
            + Add Webhook
          </a>
        </div>

        <DataTable
          data={this._filterKeysForWebhookDataTable()}
          title="Webhooks"
          actions={[
            {
              title: "edit",
              icon: "fa-edit",
              action: (modelInstance) => this.onOpenEditModal(modelInstance),
            },
          ]}
        />

        <BaseModal
          open={this.state.editModalOpen}
          onClose={this.onCloseEditModal}
          center
        >
          <BaseForm
            inputs={this.state.formInputs}
            onCancel={this.onCloseEditModal}
            onSubmit={this.handleUpdateCreateSubmission}
          />
          {!!this.state.editModalErrorMsg && (
            <div className="danger-text flx center">
              {this.state.editModalErrorMsg}
            </div>
          )}
        </BaseModal>
      </div>
    );
  }
}

export default WebhooksTab; 